import { render } from "./TasksModal.vue?vue&type=template&id=23311ade&scoped=true"
import script from "./TasksModal.vue?vue&type=script&lang=js"
export * from "./TasksModal.vue?vue&type=script&lang=js"

import "./TasksModal.vue?vue&type=style&index=0&id=23311ade&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23311ade"]])

export default __exports__